/* eslint formatjs/no-literal-string-in-jsx: "error" */
import React from "react"
import { colors, Container, FlexContainer, Icon, shadows, sizing, Text } from "@carrotfertility/carotene"
import styled from "styled-components"
import { filterParentIdByBenefitConfig, FormattedProviderTypesList } from "../../utils/parentIdMapping"
import { Benefit } from "pages/provider-finder/types/Benefit"
import { FormattedMessage } from "react-intl"

const StyledAnchorButton = styled.button<{ open: boolean }>((props) => ({
  display: "block",
  width: "100%",
  borderWidth: "2px",
  borderStyle: "solid",
  lineHeight: 1.5,
  fontWeight: 500,
  background: "white",
  padding: "16px 14px",
  borderRadius: "6px",
  boxShadow: shadows.light,
  cursor: "pointer",
  borderColor: props.open ? colors.base.carrotOrange : "white",
  "&:hover,&:focus-within,&:focus-visible": {
    borderColor: colors.base.carrotOrange,
    outline: "none"
  }
}))

type ProviderTypeAnchorButtonProps = {
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
  open: boolean
  providerType: string[]
  benefit: Benefit
}
export function ProviderTypeAnchorButton({
  setOpen,
  open,
  providerType,
  benefit
}: ProviderTypeAnchorButtonProps): JSX.Element {
  const validProviderTypes = providerType.filter(filterParentIdByBenefitConfig(benefit))
  const displayText = validProviderTypes.length ? (
    <Container
      sx={{
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        width: "100%",
        maxHeight: "24px",
        maxWidth: ["calc(100vw - 180px)", "calc(100vw - 180px)", "calc(100vw - 380px)", "calc(100vw - 520px)"],
        textAlign: "left"
      }}
    >
      {FormattedProviderTypesList(validProviderTypes)}
    </Container>
  ) : (
    <Text weight={"normal"}>
      <FormattedMessage defaultMessage="Select provider type" />
    </Text>
  )

  function onClick(): void {
    setOpen(!open)
  }

  return (
    <StyledAnchorButton open={open} onClick={onClick} type="button">
      <FlexContainer
        direction="row"
        justifyContent={"space-between"}
        alignItems={"center"}
        gap={sizing.spacing.medium}
        maxHeight={sizing.spacing.medium}
      >
        {displayText}
        <Container>
          <Icon size="16px" name={open ? "up" : "down"} color={colors.base.carrotOrange} />
        </Container>
      </FlexContainer>
    </StyledAnchorButton>
  )
}
